import React, { useEffect } from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import InputDropdown from "./input-dropdown";
import store from "src/store";

export default function MyReviewsFilters(props) {

    useEffect(() => {
        store.checkAndSetMyReviewFilter();
    }, [store.myReviews]);

    const getAllEngagementIdList = () => {
        let engagementIds = [];
        let engagements = [];

        for (let i = 0; i < store.userEngagements.length; i++) {
            if (!engagementIds.includes(store.userEngagements[i].engId)) {
                engagementIds.push(store.userEngagements[i].engId);
                engagements.push(
                    {
                        label: store.userEngagements[i].organizationData.name + " / " + store.userEngagements[i].engId,
                        value: store.userEngagements[i].engId
                    }
                )
            }
        }

        engagements.unshift({
            label: 'All',
            value: 'All'
        });

        return engagements;
    }

    store.useRerenderIfChange(() => [store.myReviewFilter, store.userEngagements])

    return (
        <>
            <div css="
                    display: flex; 
                    align-items: center;
                    width: 100%;
                    justify-content: start;
                ">
                <div css="width: 20%; margin-right: 15px">
                    <InputDropdown
                        id={"engagement"}
                        label={"Filter by engagement ids"}
                        value={store.myReviewFilter.engagementId}
                        disabled={false}
                        showClearOption={store.myReviewFilter.engagementId != 'All'}
                        onClear={() => { store.updateMyReviewFilter('engagementId', 'All') }}
                        onChange={(value) => { store.updateMyReviewFilter("engagementId", value) }}
                        list={getAllEngagementIdList()}
                    />
                </div>
                <div
                    css={`cursor:pointer;display:flex; align-items: center; flex-direction: column; width: max-content; position:relative; bottom: 5px`}
                    title="Refresh"
                    onClick={async () => {
                        props.setLoading(true);
                        await store.resetMyReviewFilter();
                        props.setLoading(false);
                    }}
                >
                    <RefreshIcon style={{ color: '#000', marginTop: '13px' }} />
                    <div css={`width: max-content`}>Refresh</div>
                </div>
            </div>
        </>
    )
}